import { IRootState } from '..'

export const getAdmin = (state: IRootState, id: string) =>
  state.adminState.admins.filter(admin => admin.id === id)[0]
